import {
  FiCheckCircle,
  FiXCircle,
  FiCalendar,
  FiThermometer,
  FiSun,
  FiClock,
  FiDollarSign,
  FiGift,
} from 'react-icons/fi';

export const userLeaveEnum = {
  present: 'present',
  absent: 'absent',
  weekOff: 'weekOff',
  holiday: 'holiday',
  sickLeave: 'sickLeave',
  casualLeave: 'casualLeave',
  plannedLeave: 'plannedLeave',
  unpaidLeave: 'unpaidLeave',
};
export const userLeaveLabelEnum = {
  present: 'Present',
  absent: 'Absent',
  weekOff: 'Week Off',
  holiday: 'Holiday',
  sickLeave: 'Sick Leave',
  casualLeave: 'Casual Leave',
  plannedLeave: 'Planned Leave',
  unpaidLeave: 'Unpaid Leave',
};
export const userLeaveLabelEnumMapping = {
  'week off': userLeaveEnum.weekOff,
  holiday: userLeaveEnum.holiday,
  'sick leave': userLeaveEnum.sickLeave,
  'casual leave': userLeaveEnum.casualLeave,
  'planned leave': userLeaveEnum.plannedLeave,
  'unpaid leave': userLeaveEnum.unpaidLeave,
  present: userLeaveEnum.present,
  absent: userLeaveEnum.absent,
};

// Matches the `iconColor` tokens on userLeaveBalanceConfig below so a status
// (e.g. "Present") is the same color on the stat-card icon, calendar pill,
// and donut/legend. Literal hex, not var(--...) — recharts' SVG `fill` and
// inline pill backgrounds don't reliably resolve CSS custom properties.
export const userLeaveColorConfig = {
  [userLeaveEnum.present]: '#039855', // success-600
  [userLeaveEnum.absent]: '#E31B54', // rose-600
  [userLeaveEnum.weekOff]: '#DC6803', // warning-600
  [userLeaveEnum.holiday]: '#8200E6', // violet-600
  [userLeaveEnum.sickLeave]: '#0086C9', // blue-light-600
  [userLeaveEnum.casualLeave]: '#6938EF', // purple-600
  [userLeaveEnum.plannedLeave]: '#1570EF', // blue-600
  [userLeaveEnum.unpaidLeave]: '#EC4A0A', // orange-600
};

export const userLeaveBalanceConfig = [
  {
    label: userLeaveLabelEnum.present,
    color: userLeaveColorConfig[userLeaveEnum.present],
    key: userLeaveEnum.present,
    icon: FiCheckCircle,
    iconBg: 'success-100',
    iconColor: 'success-600',
  },
  {
    label: userLeaveLabelEnum.absent,
    color: userLeaveColorConfig[userLeaveEnum.absent],
    key: userLeaveEnum.absent,
    icon: FiXCircle,
    iconBg: 'rose-100',
    iconColor: 'rose-600',
  },
  {
    label: userLeaveLabelEnum.weekOff,
    color: userLeaveColorConfig[userLeaveEnum.weekOff],
    key: userLeaveEnum.weekOff,
    icon: FiCalendar,
    iconBg: 'warning-100',
    iconColor: 'warning-600',
  },
  {
    label: userLeaveLabelEnum.holiday,
    color: userLeaveColorConfig[userLeaveEnum.holiday],
    key: userLeaveEnum.holiday,
    icon: FiGift,
    iconBg: 'violet-100',
    iconColor: 'violet-600',
  },
  {
    label: userLeaveLabelEnum.sickLeave,
    color: userLeaveColorConfig[userLeaveEnum.sickLeave],
    key: userLeaveEnum.sickLeave,
    icon: FiThermometer,
    iconBg: 'blue-light-100',
    iconColor: 'blue-light-600',
  },

  {
    label: userLeaveLabelEnum.casualLeave,
    color: userLeaveColorConfig[userLeaveEnum.casualLeave],
    key: userLeaveEnum.casualLeave,
    icon: FiSun,
    iconBg: 'purple-100',
    iconColor: 'purple-600',
  },
  {
    label: userLeaveLabelEnum.plannedLeave,
    color: userLeaveColorConfig[userLeaveEnum.plannedLeave],
    key: userLeaveEnum.plannedLeave,
    icon: FiClock,
    iconBg: 'blue-100',
    iconColor: 'blue-600',
  },
  {
    label: userLeaveLabelEnum.unpaidLeave,
    color: userLeaveColorConfig[userLeaveEnum.unpaidLeave],
    key: userLeaveEnum.unpaidLeave,
    icon: FiDollarSign,
    iconBg: 'orange-100',
    iconColor: 'orange-600',
  },
];
